export const SORTER_ENDPOINTS = {
	listPlans: "sorter/plans",
	createPlan: "sorter/plans",
	plan: (planId: number) => `sorter/plans/${planId}`,
	planDetail: (planId: number) => `sorter/plans/${planId}/detail`,
	planSlots: (planId: number) => `sorter/plans/${planId}/slots`,
	activatePlan: (planId: number) => `sorter/plans/${planId}/activate`,
	updateSlot: (planId: number, planSlotId: number) =>
		`sorter/plans/${planId}/slots/${planSlotId}`,
	setSlotZones: (planId: number, planSlotId: number) =>
		`sorter/plans/${planId}/slots/${planSlotId}/zones`,
} as const;
